import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  SharedModule,
  DropdownFloatingFilterComponent,
} from '@ipreo/muni-shared';
import { GamedaySharedModule } from '../shared/shared.module';
import { AccountCellRendererComponent } from '../shared/components/renderers/account-cell.component';
import { AllOrdersComponent } from './components/all-orders/all-orders.component';
import { AgGridModule } from 'ag-grid-angular';
import { ProfileModule } from '../profile/profile.module';

export const agGridModule = AgGridModule.withComponents([
  DropdownFloatingFilterComponent,
  AccountCellRendererComponent,
]);

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ProfileModule,
    ReactiveFormsModule,
    GamedaySharedModule,
    SharedModule,
    agGridModule,
  ],
  declarations: [AllOrdersComponent, AccountCellRendererComponent],
  exports: [AllOrdersComponent],
})
export class AllOrdersModule {}
